
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Share2, Award, TrendingUp } from 'lucide-react';

const FeaturesSection: React.FC = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12">Why Choose Our Referral Platform?</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <Card className="border-none hover:bg-gray-50 transition-colors">
            <CardHeader className="pb-4">
              <Share2 className="h-10 w-10 text-primary-blue mb-2" />
              <CardTitle>Easy Sharing</CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription className="text-base">
                Customers can share referrals via email, social media, or text message with just a few clicks.
              </CardDescription>
            </CardContent>
          </Card>
          
          <Card className="border-none hover:bg-gray-50 transition-colors">
            <CardHeader className="pb-4">
              <Award className="h-10 w-10 text-primary-blue mb-2" />
              <CardTitle>Reward Automation</CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription className="text-base">
                Automatically deliver rewards to customers when their referrals convert. No manual work needed.
              </CardDescription>
            </CardContent>
          </Card>
          
          <Card className="border-none hover:bg-gray-50 transition-colors">
            <CardHeader className="pb-4">
              <TrendingUp className="h-10 w-10 text-primary-blue mb-2" />
              <CardTitle>Detailed Analytics</CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription className="text-base">
                Track performance with detailed analytics. See which customers drive the most referrals and revenue.
              </CardDescription>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;

